import React, { FC, useEffect } from 'react'
import { Stripe } from 'stripe'
import { Card, CardInner, InvoiceCardBody } from 'components/Card'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getInvoices, getShopSubscriptions } from 'reducks/shopSubscription/selectors'
import { fetchShopSubscriptions, retrieveInvoices } from 'reducks/shopSubscription/operations'
import { getShopRef } from 'reducks/store/selectors'

const InvoiceCard: FC = () => {
  const dispatch = useDispatch()

  const shopRef = useSelector((state: State) => getShopRef(state))
  const shopSubscriptions = useSelector((state: State) => getShopSubscriptions(state))
  const invoices = useSelector((state: State) => getInvoices(state))

  useEffect(() => {
    if (!shopRef) return
    dispatch(fetchShopSubscriptions(shopRef))
  }, [shopRef])

  useEffect(() => {
    dispatch(retrieveInvoices(shopSubscriptions))
  }, [shopSubscriptions])

  return (
    <Card>
      <CardInner>
        {invoices.map((invoice: Stripe.Invoice) => {
          const shopSubscription = shopSubscriptions.find(
            (subscription) => subscription.stripe_subscription_id === invoice.subscription
          )
          if (!shopSubscription) return
          // 無料プランの請求書を非表示
          if (invoice.amount_due === 0) return
          return (
            <InvoiceCardBody
              key={invoice.id}
              invoice={invoice}
              isSacriStation={shopSubscription.is_sacri_station}
              storeRef={shopSubscription.store_ref}
            />
          )
        })}
      </CardInner>
    </Card>
  )
}

export default InvoiceCard
